import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=244241cc&"
import script from "./afterDetail.vue?vue&type=script&lang=js&"
export * from "./afterDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterDetail.vue?vue&type=style&index=0&id=244241cc&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244241cc')) {
      api.createRecord('244241cc', component.options)
    } else {
      api.reload('244241cc', component.options)
    }
    module.hot.accept("./afterDetail.vue?vue&type=template&id=244241cc&", function () {
      api.rerender('244241cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/afterDetail.vue"
export default component.exports